import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import TableView from '../../../../components/tableView';
import CapColumns from '../capColumns';
import { ICapEndpointRow } from '../capTypes';
import { ITemplate } from '../../../../common/types/templateTypes';

interface IListCapProps {
  rows: ICapEndpointRow[];
  globalFilter: string;
  setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
  noDataMessage: string;
  handleCopyUrl: (endpointToken: string, id: string) => void;
  copiedId: string | null;
  handleToggleActive: (endpointId: string, isActive: boolean) => void;
  handleDelete: (endpointId: string) => void;
  handleRegenerateToken: (endpointId: string) => Promise<string | null>;
  handleEdit: (endpoint: ICapEndpointRow) => void;
  templatesById: Map<number, ITemplate>;
}

const ListCap: React.FC<IListCapProps> = ({
  rows,
  globalFilter,
  setGlobalFilter,
  noDataMessage,
  handleCopyUrl,
  copiedId,
  handleToggleActive,
  handleDelete,
  handleRegenerateToken,
  handleEdit,
  templatesById,
}) => {
  const capColumns = useMemo(
    () =>
      CapColumns(
        handleCopyUrl,
        copiedId,
        handleToggleActive,
        handleDelete,
        handleRegenerateToken,
        handleEdit,
        templatesById
      ),
    [
      handleCopyUrl,
      copiedId,
      handleToggleActive,
      handleDelete,
      handleRegenerateToken,
      handleEdit,
      templatesById,
    ]
  );

  return (
    <Row>
      <Col sm={12}>
        <div className="dm-table-container cap-endpoints-table">
          <TableView
            data={rows}
            columns={capColumns}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            noDataMessage={noDataMessage}
          />
        </div>
      </Col>
    </Row>
  );
};

export default ListCap;
